import React, { useState } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const ReservationTimePicker = () => {
  const [selectedTime, setSelectedTime] = useState(null);

  const handleTimeSelection = (time) => {
    setSelectedTime(time);
  };

  return (
    <div classname='Reservation'>
      <h2>Select Reservation Time</h2>
      
      <DatePicker
        className='ReservationTimePicker'
        selected={selectedTime}
        onChange={handleTimeSelection}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
        timeFormat="HH:mm"
        timeIntervals={15}
      />
      <p>Selected Time: {selectedTime && moment(selectedTime).format('MMMM d, yyyy h:mm aa')}</p>
    </div>
  );
};

export default ReservationTimePicker;

